import { render, staticRenderFns } from "./Vidas.vue?vue&type=template&id=6e86b37b"
import script from "./Vidas.vue?vue&type=script&lang=js"
export * from "./Vidas.vue?vue&type=script&lang=js"
import style0 from "./Vidas.vue?vue&type=style&index=0&id=6e86b37b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports